import {
  StyledHeader,
  HeaderOverlay,
  HeaderBorder,
  GradientText,
  FlexContainer,
} from "../styled";
import styled from "styled-components";
import NovaTokenImage from "../../assets/images/logo/tokens/nova.png";
import TonTokenImage from "../../assets/images/logo/tokens/ton.png";
import MiningIcon from "../../assets/icons/mining.gif";
import { useUserContext } from "../../context/UserContext";
import { useEffect, useState } from "react";
import { formatNumber } from "../../utils";
import { useTokenContext } from "../../context/TokenContext";
import { getNovaPrice } from "../../service/main/api";
const Header = () => {
  const [userBalance, setUserBalance] = useState(0);
  const { user } = useUserContext();
  const {tokens} = useTokenContext();
  const [novaPrice, setNovaPrice] = useState(0);
  const [rewardPollBalance, setRewardPollBalance] = useState(0);
      useEffect(() => {
        if(!tokens || !user) return;
        const novaToken = tokens.find(t => t.symbol === "NOVA");
        if(!novaToken) return;
        const balance = user.balances[novaToken._id];
        if(balance){
            setUserBalance(balance);
        }
    },[user,tokens]);
    useEffect(() => {
        const fetchNovaPrice = async () => {
            const res = await getNovaPrice();
            if(res?.success){
                setNovaPrice(Number(res.data));
            }
        }
        fetchNovaPrice();
    }, []);
  return (
    <StyledHeader>
      <HeaderOverlay />
      <HeaderBorder />
      <ContentArea>
        <ContentTop>
          <TokenIcon src={NovaTokenImage} alt="Nova Token" />
          <TokenAmountText>{userBalance?.toFixed(2) || 0.0}</TokenAmountText>
          <TokenValueText> = {(userBalance * novaPrice)?.toFixed(6) || 0.0} USD</TokenValueText>
        </ContentTop>
        <ContentBottom>
          <MiningIconImage src={MiningIcon} alt="Mining" />
          <MiningIconText>
            Mining Power: {formatNumber(user?.activeMiningPower)} /day
          </MiningIconText>
        </ContentBottom>
       <FlexContainer gap="4px">
          <GradientText style={{ fontSize: "12px" }}>
            Nova Price: {novaPrice ? `$${novaPrice.toFixed(6)}` : "Loading..."}
          </GradientText>
        </FlexContainer>
      </ContentArea>
    </StyledHeader>
  );
};
const ContentArea = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    padding: 8px 16px;
    z-index: 1;
`
const ContentTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`
const ContentBottom = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 0.3em;
    margin-bottom: 0.3em;
`  
const TokenAmountText = styled(GradientText)`
    font-size: 1.1em;
    font-weight: 800;
    margin-left: 8px;
`
const TokenValueText = styled(GradientText)`
    font-size: 1em;
    margin-left: 8px;
`
const TokenIcon = styled.img`
    width: 1.1em;
    max-width: 32px;
`
const MiningIconImage = styled.img`
    width: 3vw;
    max-width: 18px;
    `
const MiningIconText = styled(GradientText)`
    font-size: 12px;
    font-weight: 600;
    margin-left: 8px;
`
export default Header;